import React from "react";
import "../../styles/fixed-layout-tb.css";
import {
  convertThenFormat,
  formatDateTimezon,
  formattedAmount,
} from "../common-data/Converts";

const FixedLayoutTable = ({ name, tbCols, tbColumns, onClickData }) => {
  const sortedData = [...tbColumns];
  sortedData.sort(
    (a, b) => new Date(b.truncated_date) - new Date(a.truncated_date)
  );

  return (
    <section
      className="fixed-layout-tb-container"
      style={{ marginTop: name === "dashboard-card" ? "15px" : 0 }}
    >
      <div className="tbl-header">
        <table cellPadding={0} cellSpacing={0} border={0}>
          <thead>
            <tr>
              {tbCols.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
        </table>
      </div>
      <div
        className="tbl-content"
        style={{ height: name === "dashboard-card" ? "95vh" : "300px" }}
      >
        <table cellPadding={0} cellSpacing={0} border={0}>
          <tbody>
            {sortedData.map((row, index) => (
              <React.Fragment key={index}>
                {name === "pt_revenue" ? (
                  <tr>
                    <td>
                      <span
                        className="cus-tb-data tb-data-bold tb-data-click"
                        onClick={() =>
                          row?.truncated_date
                            ? onClickData(row.truncated_date)
                            : null
                        }
                      >
                        {row?.truncated_date
                          ? formatDateTimezon(row.truncated_date)
                          : "-"}
                      </span>
                    </td>
                    <td>
                      ₹
                      {row.total_price
                        ? convertThenFormat(row.total_price)
                        : "0"}
                    </td>
                  </tr>
                ) : name === "dashboard-card" ? (
                  <tr>
                    <td>
                      <span className="cus-tb-data">
                        {row?.gym_name || "NA"}
                      </span>
                    </td>
                    <td>
                      <span className="cus-tb-data">
                        ₹
                        {formattedAmount(
                          parseInt(row?.target_value || 0) || 0
                        ) || "0"}
                      </span>
                    </td>
                    <td>
                      <span className="cus-tb-data">
                        ₹
                        {formattedAmount(
                          parseInt(row?.target_acheived || 0) || 0
                        ) || "0"}{" "}
                        {parseInt(row?.target_acheived || 0) <
                        parseInt(row?.target_value || 0) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-arrow-down-short"
                            viewBox="0 0 16 16"
                            style={{ color: "#E41815" }}
                          >
                            <path
                              fillRule="evenodd"
                              d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-arrow-up-short"
                            viewBox="0 0 16 16"
                            style={{ color: "#209216" }}
                          >
                            <path
                              fillRule="evenodd"
                              d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5"
                            />
                          </svg>
                        )}
                      </span>
                    </td>
                    <td>
                      <span className="cus-tb-data">
                        ₹
                        {row?.target_value > 0
                          ? formattedAmount(
                              parseInt(row?.target_value || 0).toFixed(2) -
                                parseInt(row?.target_acheived || 0).toFixed(
                                  2
                                ) || 0
                            )
                          : 0}
                      </span>
                    </td>
                  </tr>
                ) : null}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default FixedLayoutTable;
